import React from "react";
import "../css/LLMResults.css";
import "../css/Main.css";

interface ResultData {
  question: string;
  results: {
    [llm: string]: "✓" | "✗" | "?" | "";
  };
}

const LLMResults: React.FC = () => {
  const llmModels = [
    "Claude 3.7",
    "ChatGPT 4.5",
    "ChatGPT 4o",
    "Grok",
    "Claude 3.7 Thinking",
    "o3-mini-high",
    "o1",
    "o1 Pro",
    "Grok Thinking",
    "Deepseek r1",
    "Gemini 2.0 Flash Thinking"
  ];

  const resultsData: ResultData[] = [
    {
      question: "The Monty Shuffle",
      results: {
        "Claude 3.7": "✓",
        "ChatGPT 4.5": "?",
        "ChatGPT 4o": "✓",
        "Grok": "✓",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✓"
      }
    },
    {
      question: "The Monty Fall",
      results: {
        "Claude 3.7": "✗",
        "ChatGPT 4.5": "?",
        "ChatGPT 4o": "✗",
        "Grok": "✓",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✗"
      }
    },
    {
      question: "Mo Goats, Mo Open Doors",
      results: {
        "Claude 3.7": "✗",
        "ChatGPT 4.5": "✓",
        "ChatGPT 4o": "?",
        "Grok": "✓",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✓"
      }
    },
    {
      question: "The Mo Goats the Mo Problems",
      results: {
        "Claude 3.7": "✗",
        "ChatGPT 4.5": "✓",
        "ChatGPT 4o": "✗",
        "Grok": "✓",
        "Claude 3.7 Thinking": "✗",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✗"
      }
    },
    {
      question: "The Baaaaaaad Apple",
      results: {
        "Claude 3.7": "✗",
        "ChatGPT 4.5": "✗",
        "ChatGPT 4o": "✗",
        "Grok": "✗",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✗"
      }
    },
    {
      question: "The Mo Goats the Mo Picks",
      results: {
        "Claude 3.7": "✗",
        "ChatGPT 4.5": "✗",
        "ChatGPT 4o": "✗",
        "Grok": "✓",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✗"
      }
    },
    {
      question: "The Eccentric Billionaire",
      results: {
        "Claude 3.7": "✗",
        "ChatGPT 4.5": "✗",
        "ChatGPT 4o": "✗",
        "Grok": "✗",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✗"
      }
    },
    {
      question: "The Tracker",
      results: {
        "Claude 3.7": "✗",
        "ChatGPT 4.5": "✗",
        "ChatGPT 4o": "✗",
        "Grok": "✗",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✓"
      }
    },
    {
      question: "The Monty Crawl",
      results: {
        "Claude 3.7": "✗",
        "ChatGPT 4.5": "✗",
        "ChatGPT 4o": "✗",
        "Grok": "✗",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✗",
        "o1": "✓",
        "o1 Pro": "✓",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✓"
      }
    },
    {
      question: "The Corrupt Monty",
      results: {
        "Claude 3.7": "✓",
        "ChatGPT 4.5": "✓",
        "ChatGPT 4o": "✓",
        "Grok": "✓",
        "Claude 3.7 Thinking": "✓",
        "o3-mini-high": "✓",
        "o1": "✓",
        "o1 Pro": "✗",
        "Grok Thinking": "✓",
        "Deepseek r1": "✓",
        "Gemini 2.0 Flash Thinking": "✓"
      }
    }
  ];

  const calculateTotals = () => {
    const totals: { [llm: string]: { correct: number; total: number } } = {};
    
    llmModels.forEach(llm => {
      totals[llm] = { correct: 0, total: 0 };
    });

    resultsData.forEach(row => {
      llmModels.forEach(llm => {
        if (row.results[llm] !== "") {
          totals[llm].total++;
          if (row.results[llm] === "✓") {
            totals[llm].correct++;
          } else if (row.results[llm] === "?") {
            totals[llm].correct += 0.5;
          }
        }
      });
    });

    return totals;
  };

  const totals = calculateTotals();

  return (
    <div className="llm-results-container content-container">
      <h2>Monty Hall Variants: LLM Performance</h2>
      
      <div className="table-container">
        <table className="llm-results-table">
          <thead>
            <tr>
              <th className="question-column">Question</th>
              {llmModels.map(llm => (
                <th key={llm}>{llm}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {resultsData.map((row, index) => (
              <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                <td className="question-cell">{row.question}</td>
                {llmModels.map(llm => (
                  <td 
                    key={`${row.question}-${llm}`} 
                    className={`result-cell ${
                      row.results[llm] === "✓" 
                        ? "correct" 
                        : row.results[llm] === "✗" 
                          ? "incorrect" 
                          : row.results[llm] === "?"
                            ? "unclear"
                            : "empty"
                    }`}
                  >
                    {row.results[llm]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="totals-row">
              <td className="totals-label">Success Rate</td>
              {llmModels.map(llm => (
                <td key={`total-${llm}`} className="totals-cell">
                  {totals[llm].total > 0 
                    ? `${totals[llm].correct}/${totals[llm].total}` 
                    : "-"}
                </td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="fine-print">
        <p><strong>Fine Print:</strong></p>
        <ol>
          <li>Models were asked the exact question text in a fresh chat each time and given the multiple choice responses in the form of a question. No other context was given.</li>
          <li>Unclear means models gave a conflicting final answer that contained the correct answer.
            <ul>
              <li>ChatGPT 4.5 liked to switch because "it might help", though it did clearly say it didn't matter.</li>
              <li>4o gave the wrong answer in its first sentence, then corrected itself at the end.</li>
            </ul>
          </li>
          <li>Some questions are likely in some model's training data</li>
        </ol>
      </div>
    </div>
  );
};

export default LLMResults;
